<div mat-dialog-title class="flex-container">
    <button mat-button class="close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
    <h1>{{data.coderName}}</h1>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="manageCoderForm">

        <div class="row">
            <div class="col-md-5">
              <p>Coder Level<span>*</span></p>
              <mat-form-field appearance="none" class="manage-select">
                  <mat-select formControlName="coderLevel" class="input1"
                       required>
                      <mat-option value="CODER_LEVEL_1">CODER_LEVEL_1</mat-option>
                      <mat-option value="CODER_LEVEL_2">CODER_LEVEL_2</mat-option>
                  </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-5">
              <p>% QA Needed<span>*</span></p>
              <mat-form-field appearance="none" class="manage-input">
                  <input matInput type="number" (keypress)="numberOnly($event)" formControlName="qaNeeded"
                      class="input1" min="0" max="100" maxlength="3" required />
              </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-md-5">
              <p>Clients<span>*</span></p>
              <mat-form-field appearance="none" class="manage-select">
                  <mat-select formControlName="assignedClients" (selectionChange)="getProjectsByClient($event)"
                      placeholder="Select Client" multiple required>
                      <mat-option *ngFor="let client of clients" [disabled]="enableReset" [value]="client.clientId">{{ client.clientName }}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
            </div>
 
            <div class="col-md-5">
              <p>Projects<span>*</span></p>
              <mat-form-field appearance="none" class="manage-select">
                  <mat-select formControlName="assignedProjects" multiple placeholder="Select Project" (openedChange)="panelSelected($event)" required>
                      <mat-option *ngFor="let project of projects" [disabled]="enableReset" [value]="project.projectId">{{ project.clientName }} - {{ project.projectName}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-2">
                <button mat-raised-button mat-button
                  class="btn btn-icon-text3 md-button-right top-pad" [disabled]="!enableReset" (click)="changeResetButton()">
                  RESET
                </button>
            </div>
        </div>

        <!-- <div class="row">
          <div class="col-lg-12">
            <div>
              <p>Assigned Client & Projects</p>
              {{this.data.assignedProjects}}
              <ul style="padding: 0px;">
                  <li *ngFor="let project of projects" [disabled]="enableReset" [value]="project.projectId">{{ project.clientName }} - {{ project.projectName}}
                  </li>
              </ul>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col-lg-12 toparea">
              <button mat-raised-button btn-primary appNoDblClickMat [disabled]="!manageCoderForm.valid"
                      (click)="onSubmit()" type="submit" class="btn btn-icon-text3">UPDATE</button>
            </div>
        </div>

    </form>
  </div>